import React from "react";
import Chip from "@material-ui/core/Chip";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { ExpandMore, ExpandLess, Close } from "@material-ui/icons";
import {
  IMPORT_ISSUE_PALETTE,
  ImportIssueColor,
} from "./importIssuePalette";

export type ImportIssueChipColor = ImportIssueColor;

type ImportIssueChipProps = {
  label: string;
  icon: React.ReactElement;
  filterKey: string;
  activeFilter: string | null;
  onActiveFilterChange: (filter: string | null) => void;
  removeTooltip: string;
  onRemove: () => void;
  color?: ImportIssueChipColor;
  groupClassName?: string;
  removeButtonClassName?: string;
};

const ImportIssueChip = ({
  label,
  icon,
  filterKey,
  activeFilter,
  onActiveFilterChange,
  removeTooltip,
  onRemove,
  color = "warning",
  groupClassName,
  removeButtonClassName,
}: ImportIssueChipProps) => {
  const palette = IMPORT_ISSUE_PALETTE[color];
  const isActive = activeFilter === filterKey;

  const toggleFilter = () => {
    onActiveFilterChange(isActive ? null : filterKey);
  };

  const iconWithColor = React.cloneElement(icon, {
    style: {
      ...icon.props.style,
      color: palette.iconColor,
      fontSize: 18,
      marginLeft: 8,
    },
  });

  return (
    <div className={groupClassName}>
      <Chip
        clickable
        icon={iconWithColor}
        label={label}
        onClick={toggleFilter}
        onDelete={toggleFilter}
        deleteIcon={
          isActive ? (
            <ExpandLess style={{ color: palette.iconColor }} />
          ) : (
            <ExpandMore style={{ color: palette.iconColor }} />
          )
        }
        style={{
          cursor: "pointer",
          color: palette.color,
          border: palette.border,
          backgroundColor: isActive ? palette.backgroundActive : palette.background,
        }}
      />
      <Tooltip title={removeTooltip}>
        <IconButton
          className={removeButtonClassName}
          style={{ color: palette.removeButtonColor }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ImportIssueChip;
